// removed by extract-text-webpack-plugin
module.exports = {"Container":"_87dIvCCM9WjUPtOGK8Av3","Title":"_2OZrHMTyNL50ss02PnBroR","MasterToggle":"_1vxRBudBh80SfjIFlc4RAi","Group":"IvUO-cQcMtYdq1AqSQ-gK","GroupTitle":"_35jC_OwaY3yQGd_tB2uJzZ","Toggle":"_1LSEYH5CLoSGhAPeJHm5cb","ToggleInfo":"_2jnzREVrhGBXa0jQq_Fh5w","ToggleLabel":"_1vHCzo6SAs1vEy6U3uiac3","ToggleDesc":"_3FVTgzogb6gZpOMbuJvC93","PaidBadge":"_1r9uRDVKTWupVr4S-yFiKV","FreeBadge":"_1c_4FFRYEfmqgyjeRL8_by","SaveBtn":"_12qfklzIV1fnBtAjE7lwco","StatusMsg":"_2ujXey71e5ETJ6Sfoh_7-2","StatusSuccess":"-pNsI3j0QLBAaAyDC4_ut","StatusError":"M6E3JtSw-2-CyaEwqHzpJ","Disabled":"_2wn0L6-TJpFODaW1FOBJ4m"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/AntiFraudConfigTab/styles.module.css
// module id = 524
// module chunks = 0